module.exports = __webpack_public_path__ + "static/media/down-arrow-white_icon.32c05803.svg";